module.exports = __webpack_public_path__ + "static/img/nuevos_04.d64ade48.jpg";